import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "../../components/navbar";
import { Footer } from "../../components/footer";

export const AdminLayout: React.FC = () => (
  <div className="max-w-7xl mx-auto min-h-screen flex flex-col justify-between">
    <div>
      <Navbar />
      <main className="px-4 md:px-6 py-6 md:py-8 max-w-7xl mx-auto gap-4 flex flex-col">
        <Outlet />
      </main>
    </div>
    <Footer />
  </div>
);

export const PageStatus: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="py-12 text-center text-gray-600">{children}</div>
);
